import UnbindedSubcategories from "../symbols/unbindedSubcategories";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

function UnbindedSubcategoriesReducer(state = initialState, action: any) {
  switch (action.type) {
    case UnbindedSubcategories.UNBINDED_SUBCATEGORIES:
      return { ...state, loading: true, error: false };
    case UnbindedSubcategories.UNBINDED_SUBCATEGORIES_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case UnbindedSubcategories.UNBINDED_SUBCATEGORIES_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case UnbindedSubcategories.CLEAR_UNBINDED_SUBCATEGORIES:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
export default UnbindedSubcategoriesReducer;
